import client from '@/graphql/client'
import StartCodeGeneration from '@/graphql/mutations/StartCodeGeneration'

export async function startCodeGeneration ({
  boundedContextId,
  workflowId,
  aiVersion = 11,
  includeBackend = true,
  includeFrontend = false,
  specificDomainIds = null
}) {
  const res = await client.query({
    operationName: 'startCodeGeneration',
    query: StartCodeGeneration,
    variables: {
      boundedContextId,
      workflowId,
      aiVersion,
      includeBackend,
      includeFrontend,
      specificDomainIds
    }
  })

  return res.startCodeGeneration
}
